  <template>
  <transition name="shadow">
    <div class="shadow-warp" v-show="visible" @click.self="quit">
      <transition name="slide">
        <div class="register-warp" v-show="visible">
          <div class="title-warp">
            <div class="logo"></div>
            <span class="title">云集</span>
            <span class="desc">全球精品超市</span>
          </div>
          <div class="content-warp">
            <h1 class="title">获取你的登录手机号码</h1>
            <div class="input-warp">
              <div class="input" @click="$refs.mob.focus()">
                <span class="label">手机号</span>
                <input 
                  ref="mob"
                  @focus="checkTel"
                  @blur="inputBlur"
                  @click="inputClicked"
                  autocomplete="off"
                  maxlength="11"
                  type="tel"
                  placeholder="请输入11位手机号码" 
                  v-model.trim="loginTel"
                />
              </div>
              <div class="input" @click="$refs.code.focus()">
                <span class="label">验证码</span>
                <input
                  ref="code"
                  @click="$refs.code.focus()"
                  autocomplete="off"
                  @blur="inputBlur"
                  maxlength="6"
                  type="tel"
                  placeholder="请输入验证码"
                  v-model.trim="loginCode"
                />
                <button class="btn" @click="getCodeHandle" :disabled="isGetting">{{btnText}}</button>
              </div>
            </div>
            <p class="desc">新用户注册免费升级为钻石会员</p>
            <div class="btn-warp">
              <div class="btn grey" @click="quit">取消</div>
              <div class="btn green" @click="login">登录</div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>
<script>
import { Toast } from '@yunji/h5'

export default {
  name: 'register',
  props: {
    visible: {
      required: true,
      type: Boolean
    },
    getCode: {
      type: Function,
      required: true
    },
    onSumbit: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      loginTel: '',
      loginCode: '',
      countDownSecond: 60,
      isGetting: false
    }
  },
  methods: {
    inputClicked() {
      this.$refs.mob.focus()
      this.$emit('beginEnterPhoneNum')
    },
    inputBlur() {
      window.scrollTo(0, 0)
    },
    /**
     * 判断input框输入手机号是否符合规则
     */
    checkTel() {
      if (this.loginTel.length >= 11) {
        return this.checkPhone()
      }
      return false
    },
    /**
     * 判断手机号是否符合规则
     */
    checkPhone() {
      if (!new RegExp('^1[0-9]{10}$').test(this.loginTel)) {
        Toast('请输入正确的手机号码')
        return false
      }
      return true
    },
    /**
     * 判断输入验证码是否存在不符合规则
     */
    checkCode() {
      if (this.loginCode.length != 6) {
        Toast('请输入正确验证码')
        return false
      }
      return true
    },
    /**
     * 获取验证码点击事件
     */
    async getCodeHandle() {
      this.isGetting = true
      const isValidatePhone = this.checkPhone()
      if (isValidatePhone) {
        const getCodeSuccess = await this.getCode(this.loginTel)
        if (getCodeSuccess) {
          this.countDown()
          return
        }
      }
      this.isGetting = false
    },
    /**
     * 获取验证码倒数
     */
    countDown() {
      setTimeout(() => {
        if (this.countDownSecond && this.countDownSecond !== 0) {
          this.countDownSecond -= 1
          this.countDown()
        } else {
          this.countDownSecond = 60
          this.isGetting = false // 用于控制按钮是否可点击
        }
      }, 1000)
    },
    quit() {
      this.$emit('update:visible', false)
    },
    login() {
      const isValidatePhone = this.checkPhone()
      const isValidateCode = this.checkCode()
      if (isValidatePhone && isValidateCode) {
        this.onSumbit(this.loginTel, this.loginCode)
      }
    }
  },
  computed: {
    btnText() {
      if (this.countDownSecond === 60) {
        return '获取验证码'
      }
      return `${this.countDownSecond}S` 
    }
  }
}
</script>

<style lang="less" scoped>
  .shadow-warp{
    position: fixed;
    background: rgba(0, 0, 0, .5);
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    transition: all .2s;
    z-index: 1000;
  }
  .register-warp{
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    background: #fff;
    border-radius: 12px 12px 0 0;
    box-sizing: border-box;
    padding: 11px 16px;
    .title-warp{
      line-height: 18px;
      .logo{
        display: inline-block;
        width: 26px;
        height: 26px;
        background: url("//static.yunjiglobal.com/qnUpload/frontend/yjlogo.png") no-repeat;
        background-size: 100%;
        position: relative;
        top: 8px;
      }
      .title{
        margin: 0 15px;
        font-size: 14px;
        color: #262626;
        letter-spacing: 0;
        font-weight: 600;
      }
      .desc{
        font-size: 14px;
        color: #666666;
        letter-spacing: 0;
      }
    }
    .content-warp{
      .title{
        font-weight: 600;
        font-size: 16px;
        color: #262626;
        letter-spacing: 0;
        line-height: 20px;
        margin-top: 18px;
      }
      .input-warp{
        .input{
          width: 100%;
          background: #F7F7F7;
          border-radius: 12px;
          line-height: 52px;
          margin-top: 12px;
          display: flex;
          align-items:center;
          box-sizing: border-box;
          height: 52px;
          padding: 0 .24rem;
          font-size: 16px;
          .label{
            font-weight: 600;
            color: #333333;
            letter-spacing: 0;
            margin-right: 20px;
          }
          input{
            flex: 1;
            height: 100%;
            min-width: 0;
          }
          .btn{
            border: none;
            background: #FF3C44;
            border-radius: 4px;
            font-size: 14px;
            color: #FFFFFF;
            height: 32px;
            line-height: 32px;
            box-sizing: border-box;
            padding: 0 12px;
          }
        }
      }
      .desc{
        font-size: 13px;
        color: #999999;
        letter-spacing: 0;
        line-height: 18px;
        margin-top: 10px;
      }
      .btn-warp{
        display: flex;
        justify-content:center;
        margin-top: 35px;
        padding-bottom: 60px;
        .btn{
          border-radius: 4px;
          width: 2.2rem;
          height: 36px;
          line-height: 36px;
          font-size: 16px;
          text-align: center;
          &:not(:last-child){
            margin-right: 12px;
          }
        }
        .grey{
          background: #EDEDED;
          color: #4CC34B;
        }
        .green{
          background: #4CC34B;
          color: #fff;
        }
      }
    }
  }
  .slide-enter-active {
    animation-name: slideInUp;
    animation-duration: .3s;
    animation-fill-mode: both;
  }
  .slide-leave-active {
    animation-name: slideOutDown;
    animation-duration: .3s;
    animation-fill-mode: both;
  }
  @keyframes slideInUp {
    0% {
      transform: translate3d(0, 100%, 0);
      visibility: visible;
    }
    to {
      transform: translateZ(0);
    }
  }
  @keyframes slideOutDown {
    0% {
      transform: translateZ(0);
    }
    to {
      visibility: hidden;
      transform: translate3d(0, 100%, 0);
    }
  }
  .shadow-enter {
    opacity: 0;
  }
  .shadow-leave-to {
    opacity: 0;
  }
  .shadow-enter-active {
    transition:all .2s;
  }
  .shadow-leave-active {
    transition:all .2s;
  }
</style>
